// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import ElementUI from 'element-ui';
import ElementUILocale from '@/i18n/element-th';
// import ElementUILocale from 'element-ui/lib/locale/lang/th';
import Vue from 'vue';
import VueLogger from 'vuejs-logger';
// import Vuency from 'vuency';
import { sync } from 'vuex-router-sync';
import vuexI18n from 'vuex-i18n';
import translationsEn from '@/i18n/en';
import translationsTh from '@/i18n/th';
import helpers from '@/libs/helpers';

import App from '@/App';
import router from '@/router';
import store from '@/store';

// SENTRY STUFFS
import Raven from 'raven-js';
// import RavenVue from 'raven-js/plugins/vue';

// import style sheet
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/styles/main.scss';

const initApp = () => {
  /**
   * ACCESS CONTROL
   * Check if the host contained 'admin' at the beginning or not.
   * if not, show the error page
   */
  if (process.env.APP_ACCESS_CONTROL) {
    const mode = window.appConfig.SCB_BILLING_APP_MODE;
    const slug = helpers.getURLSlug();
    const accessControlSlug = mode === 'admin' ? 'admin' : '*';
    const reservedPaths = [
      'unauthorized',
      'login',
      'logout',
      'reset-password',
      'forgot-password',
      'company',
      'admins',
      'profiles',
      'users',
    ];
    let isValidSlug = false;
    if (mode === 'admin' && accessControlSlug === 'admin' && accessControlSlug === slug) {
      isValidSlug = true;
    } else if (mode === 'biller' && accessControlSlug === '*' &&
      slug !== '' && slug !== 'admin' && reservedPaths.indexOf(slug) === -1) {
      isValidSlug = true;
    }
    if (!isValidSlug) {
      // go to error page
      if (slug !== '' || reservedPaths.indexOf(slug) !== -1) {
        window.location.assign(`//${window.location.host}/`);
      }
      router.push({ name: 'UnauthorizedError' });
      if (window.appConfig.SENTRY_URL) {
        Raven.captureMessage('Unauthorized access!');
      }
    }
  }

  // enable Sentry Vue plugin
  /* if (window.appConfig.SENTRY_DSN) {
    // Raven.addPlugin(RavenVue, Vue);
    Raven
      .config(window.appConfig.SENTRY_DSN, {
        release: process.env.SCB_BILLING_APP_VERSION,
        environment: window.appConfig.SCB_BILLING_APP_ENV,
      })
      .addPlugin(RavenVue, Vue)
      .install();
  } */

  // enable persistent store of router
  sync(store, router);

  // enable i18n
  Vue.use(vuexI18n.plugin, store);

  Vue.i18n.add('en', translationsEn);
  Vue.i18n.add('th', translationsTh);
  Vue.i18n.set('th');

  // enable element UI
  Vue.use(ElementUI, { locale: ElementUILocale });

  // enable logger
  Vue.use(VueLogger, {
    // required ['debug', 'info', 'warn', 'error', 'fatal']
    logLevel: process.env.NODE_ENV === 'production' ? 'error' : 'debug',
    // optional : defaults to false if not specified
    stringifyArguments: process.env.NODE_ENV !== 'production',
    // optional : defaults to false if not specified
    showLogLevel: process.env.NODE_ENV !== 'production',
    // optional : defaults to false if not specified
    showMethodName: process.env.NODE_ENV !== 'production',
    // optional : defaults to '|' if not specified
    separator: '|',
    // optional : defaults to false if not specified
    showConsoleColors: process.env.NODE_ENV !== 'production',
  });

  // Enable concurrency management
  // Vue.use(Vuency);

  // config Vue
  Vue.config.productionTip = false;
  Vue.config.devtools = true;

  Vue.prototype.$scbAppInfo = {
    env: window.appConfig.SCB_BILLING_APP_ENV,
    build: process.env.SCB_BILLING_APP_JOB_ID,
    version: process.env.SCB_BILLING_APP_VERSION,
    mode: window.appConfig.SCB_BILLING_APP_MODE,
  };

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App },
  });
};

// const initApp = () => {};

export const mainApp = {
  initApp,
  // initApp2,
};
export const mainAppInfo = {};



// WEBPACK FOOTER //
// ./src/mainApp.js